/**
 * Retrieve Presentation Image Tool Schema
 *
 * Extract specific image from a slide shape.
 */
import { z } from "zod";
import { documentIdSchema } from "../searchPresentationImages/searchPresentationImages.schema";
// ═══════════════════════════════════════════════════════════════════════════
// PARAMS SCHEMA
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Retrieve Presentation Image parameters
 */
export const RetrievePresentationImageParamsSchema = z.object({
    uiDescription: z.string()
        .describe("Brief description (max ~15 words) of what this tool call is attempting."),
    documentId: documentIdSchema
        .describe("Deck containing the image: numeric index, 'CURRENT', or deck ID"),
    slideId: z.string()
        .min(1, "Slide ID is required")
        .describe("Slide ID from search result (e.g., 'slide_257')"),
    shapeId: z.string()
        .min(1, "Shape ID is required")
        .describe("Shape ID within the slide"),
    requirementId: z.string()
        .min(1, "Requirement ID is required")
        .describe("The requirement ID this asset fulfills"),
});
